import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export function MgtANode(props) {
    return <NodeWithMultipleHandles {...props} nodeType="mgt_a" />;
}
